
import { Component, Prop, Vue } from "vue-property-decorator";
import { systemSrv } from "./../services/system";
import router from "@/router";
import { cacheSrv } from "./../services/cache";
import store from "./../store";
import axios from "axios";
import Datepicker from "vuejs-datepicker";
import { notiSrv } from "./../services/noti";
import { isDate } from "util";

@Component({
  components: { Datepicker }
})
export default class SmartParkingForm extends Vue {
  memberAPIUrl = this.$store.getters.config.memberAPIUrl;
  CACHE_KEY_TOKEN = store.getters.tokenKeys.CACHE_KEY_TOKEN;
  MAX_PLATES = 2;
  form = false;
  cardLoading = "";

  disabledDates = {
    to: new Date(
      new Date().getFullYear() - 13,
      new Date().getMonth(),
      new Date().getDate()
    )
  };
  data = {
    profile: {},
    cards: [],
    primaryCard: {},
    memberId: null,
    gender: null
  };
  formData: any = {
    name: "",
    nric: "",
    dateofBirth: null,
    serializeGender: "",
    primaryCardNo: "",
    _new: false,
    memberId: null,
    cardNo: "",
    membershipTier: "Leo Cubs",
    membershipType: "Sunway"
  };
  processing = false;
  loadedForm = false;
  errorMessage = "";
  constructor() {
    super();
  }
  formatDate(date) {
    if(!date){
      return ""
    }
    return date.toLocaleDateString()
  }
  joinNow() {
    this.form = true;
    this.formData.name=""
    this.formData.nric=""
    this.formData.dateofBirth=null
    this.formData.serializeGender=""
    this.formData.cardNo=""
    this.formData._new = true;
    window.scrollTo(0, 0);
  }
  async created() {
    window.scrollTo(0, 0);
    await this.load();
    console.log(
      "new Date( new Date().getFullYear()-13)",
      new Date().getFullYear() - 13,
      new Date().getMonth(),
      new Date().getDate(),
      new Date(
        new Date().getFullYear() - 13,
        new Date().getMonth(),
        new Date().getDate()
      )
    );
  }
  async load() {
    console.log("LOADING LEO CUBS");
    if (this.data.memberId) {
      console.log("i got member id");
      this.loadMemberCards(this.data.memberId);
      return;
    }

    let result = await systemSrv.getLeoCubs();
    this.loadedForm = true;

    console.log("result", result);
    if (result && result.profile) {
      this.data.profile = result.profile;
      console.log("this.data.profile", this.data.profile);
      if (this.data.profile && this.data.profile["memberID"]) {
        console.log("Loading memberId", this.data.profile["memberID"]);
        this.data.memberId = this.data.profile["memberID"];
        this.formData.memberId = this.data.memberId;
        this.loadMemberCards(this.data.memberId);
      } else {
        console.log("Missing cards info. Cant setup leo cubs");
      }
    } else {
      console.log("no profile");
    }
  }
  back() {
    this.form = false;
    //window.scrollTo(0, 0);
  }
  updateDate(ev) {
    console.log(
      "Selected",
      ev,
      new Date(ev).getMonth(),
      new Date(ev).getMonth() + 1
    );
    let date = new Date(ev).getFullYear() + "-" + (new Date(ev).getMonth() + 1) + "-" + new Date(ev).getDate();
    this.formData["dateofBirth"] = new Date(
      ev.getTime() - new Date().getTimezoneOffset() * 60000
    );
  }

  async updateForm(item) {
    this.form = true;
    this.formData._new = false;
    this.formData["name"] = item.supplementaryMember.name;
    this.formData["nric"] = item.supplementaryMember.nric;

    let date = new Date(item.supplementaryMember.dateofBirth);
    this.formData["dateofBirth"] = new Date(
      date.getTime() - new Date().getTimezoneOffset() * 60000
    ); 
    this.formData["serializeGender"] =
      item.supplementaryMember.serializeGender.toLowerCase() == "m"
        ? "male"
        : "female";
    this.formData["primaryCardNo"] = item.cardInfo.primaryCardNo;
    this.formData["cardNo"] = item.cardInfo.cardNo;
    window.scrollTo(0, 0);
  }
  async loadMemberCards(memberId) {
    this.data.cards=[]
    
    console.log("loadMemberCards");
    this.cardLoading = "Loading cards";
    let result = await systemSrv.getMemberCards(memberId);
    this.loadedForm = true;

    console.log("result", result);
    if (result && result.cards) {
      this.data.primaryCard = result.cards[0];
      if(result.cardDetails){
        this.data.cards = result.cardDetails.map(itm=>{
          if(itm.cardInfo.isSupplementary){
            return itm
          }
        });
      }
      this.formData.primaryCardNo = this.data.primaryCard["cardNo"];
      this.cardLoading = "";
    } else {
      console.log("no cards");
      this.cardLoading = "";
    }
  }
  async update() {
    this.processing = true;
    this.errorMessage = "";
    let token = cacheSrv.cached(this.CACHE_KEY_TOKEN);
    if (!token) {
      console.log("No token");
      this.processing = false;
      router.push("login");
      return;
    }
    try {
      console.log("this.formData", this.formData);
      if (
        !this.formData.name ||
        !this.formData.nric ||
        !this.formData.serializeGender ||
        !this.formData.dateofBirth
      ) {
        this.errorMessage = "Please complete the form and try again";
        this.processing = false;
        return;
      }
      if (!this.formData.primaryCardNo) {
        this.errorMessage =
          "We could not load parent information. Please try again or contact us for assistance";
        this.processing = false;
        return;
      }

      let payload = Object.assign(
        { membershipTier: "Leo Cubs", membershipType: "Sunway" },
        this.formData
      );

      let data = await systemSrv.addSupplementaryCard(payload);
      this.processing = false;
      if (data) {
        if (data["error"]) {
          console.log("Error activating IU");
          this.errorMessage = data["meta"].original.error.message;
          return;
        }
        if (data.card) {
          //this.formData.iuList = this.adjustIUListTo4(data.iuList);
          this.form = false;
          let notiId = notiSrv.sayNoti(
            "'Leo Cubs' Member Added Successfully",
            2000
          );
        }
        if (data._new == false) {
          this.form = false;
          let notiId = notiSrv.sayNoti(
            "'Leo Cubs' Member Updated Successfully",
            2000
          );
        }

        this.loadMemberCards(this.data.memberId);
      } else {
        console.log("Error adding leo cubs member. No card returned");
      }
    } catch (error) {
      console.log("Error adding leo cubs member", error);
      this.errorMessage =
        "Error white saving new 'Leo Cubs' member. " + error.error;
    }
  }
}
